module.exports = __webpack_public_path__ + "fonts/TT_Commons_Pro_300_Regular.0a4c6e2.woff";